import i18n from '@/plugins/i18n';
import Swal from 'sweetalert2';

export default class NotificationsService {
    public showToastInfoNotification(message: string): void {
        Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 5000,
            animation: false,
        }).fire({
            type: 'info',
            title: i18n.t(message).toString(),
        });
    }

    public showToastSuccessNotification(message: string): void {
        Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 5000,
            animation: false,
        }).fire({
            type: 'success',
            title: i18n.t(message).toString(),
        });
    }

    public showToastWarningNotification(message: string): void {
        Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 5000,
            animation: false,
        }).fire({
            type: 'warning',
            title: i18n.t(message).toString(),
        });
    }

    public showToastErrorNotification(message?: string): void {
        Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 5000,
            animation: false,
        }).fire({
            type: 'error',
            title: message ? i18n.t(message!).toString() : i18n.t('common.validation.standardErrorMsg').toString(),
        });
    }
}

export const notificationsService = new NotificationsService();
